import { CgOptions } from "react-icons/cg";
import { FaLock, FaSync } from "react-icons/fa";
import { IoMdOptions } from "react-icons/io";


export function EdgeInstructions({ isMobile }: { isMobile: boolean }) {
  const instructions =
    isMobile
      ? [
        {
          icon: <FaLock />, text: <>לחץ על סמל המנעול ליד כתובת האתר בשורת הכתובת</>
        },
        { icon: <IoMdOptions />, text: 'בחר ב"הרשאות"' },
        { icon: <FaSync />, text: "אפשר הצגת התראות" },
      ]
      : [
        { icon: <CgOptions />, text: "לחץ על סמל המנעול ליד כתובת האתר בשורת הכתובת" },
        { icon: <FaSync />, text: 'לחץ על "התראות" ובחר "אפשר"' },
      ]

  return (
    <ol className="space-y-4">
      { instructions.map((instruction, index) => (
        <li key={ index } className="flex items-center space-x-4 rtl:space-x-reverse">
          <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-purple-600 rounded-full text-white">
            { instruction.icon }
          </span>
          <span className="text-gray-200">{ instruction.text }.</span>
        </li>
      )) }
    </ol>
  )
}

